/* 🤖 this file was generated by svg-to-ts */
export const mgcIconUpSmallCuteFi: {
  name: 'up-small-cute-fi';
  data: string;
} = {
  name: 'up-small-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.711 8.8c-.481.084-.779.248-1.49.82a11.29 11.29 0 0 0-2.188 2.395c-.291.441-.371.699-.341 1.091.041.549.327.975.833 1.24.196.104.252.113.635.114.369 0 .447-.013.64-.104.283-.134.471-.32.834-.829.323-.454 1.258-1.447 1.361-1.447.078 0 .843.758 1.114 1.104.105.134.294.386.42.56.27.373.44.517.766.648.208.084.287.095.602.08.297-.014.402-.038.578-.128.512-.263.795-.691.834-1.262.028-.397-.041-.61-.345-1.073-.689-1.048-1.857-2.232-2.843-2.88-.417-.275-.977-.405-1.41-.329"/></svg>`
};
